import { useState } from 'react';
import { Clients } from '../sections/clients/Clients';
import { useAdminToast } from '../shell/AdminToastContext';

export const CotizacionesPage = () => {
    const toast = useAdminToast();
    const [nodes, setNodes] = useState([]);
    const [isFetching, setIsFetching] = useState(false);

    return (
        <Clients
            nodes={nodes}
            setNodes={setNodes}
            toast={toast}
            isFetching={isFetching}
            setIsFetching={setIsFetching}
        />
    );
};

export default CotizacionesPage;
